import { useTranslation } from "react-i18next";

import { blogArticles } from "../../content/blog";
import { useLocalizedPath } from "../../seo/useLocalizedPath";
import BlogItem from "../../components/ui/BlogsPage/BlogItem/BlogItem";

import styles from "./styles.module.scss";

// Same display format as before ("Apr 10, 2025").
const formatDate = (isoDate: string) =>
  new Date(`${isoDate}T00:00:00Z`).toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
    timeZone: "UTC",
  });

const BlogsPage = () => {
  const { t } = useTranslation();
  const localizePath = useLocalizedPath();

  return (
    <div className={styles.blogsPage}>
      <div className="container">
        <div className={styles.headline}>
          <h1>{t("blogs.title")}</h1>
          <p>{t("blogs.infoTxt")}</p>
        </div>
        <div className={styles.mainContent}>
          <div className={styles.blogsWrapper}>
            {blogArticles.map((article) => (
              <BlogItem
                key={article.id}
                publishDate={formatDate(article.datePublished)}
                title={t(`${article.i18nKey}.title`)}
                href={localizePath(article.legacyPath)}
                src={article.image}
              />
            ))}
          </div>
        </div>
        <div className={styles.subscribeSection}></div>
      </div>
    </div>
  );
};

export default BlogsPage;
